import SeoLandingPage from '../SeoLandingPage';

const config = {
  seoKey: 'musicalTheatre',
  eyebrow: 'Musical Theatre Classes in Milton Keynes',
  h1: 'Musical Theatre Classes',
  h1Accent: 'in Milton Keynes',
  intro:
    'UPA is the home of musical theatre training in Milton Keynes. Every week your child builds acting, singing and dance together — exactly the way West End performers train — and finishes the year on stage in a full-scale production.',
  heroImage:
    'https://customer-assets.emergentagent.com/job_class-manager-84/artifacts/7xfauwlb_Fame-092.JPG',
  bullets: [
    {
      title: 'Triple-threat in one class',
      body: 'Singing, acting and dance taught together by industry pros — the most efficient way for a young performer to grow.',
    },
    {
      title: 'Real performances, not just classes',
      body: 'End-of-term showcases plus an annual full-scale musical production at a Milton Keynes theatre.',
    },
    {
      title: 'Faculty with West End credits',
      body: 'Our principal Sam Attwater and team have performed in EastEnders, Hollyoaks, West End musicals and UK tours.',
    },
    {
      title: 'Sibling-friendly pricing',
      body: '30% off for every additional sibling. Free trial for every new student.',
    },
  ],
  whatYouLearn: [
    { title: 'Voice & Belting', body: 'Healthy vocal technique, breath support, pitch, harmony and stagecraft singing.' },
    { title: 'Acting for Musicals', body: 'Bringing a song to life — characterisation, intent, listening, scene work.' },
    { title: 'Choreography', body: 'Jazz, contemporary, commercial and musical theatre choreography for the stage.' },
    { title: 'Audition Prep', body: 'Building a song-and-dance audition repertoire and sight-reading skills.' },
    { title: 'Ensemble Performance', body: 'Group numbers, blocking, formations and that all-important "shine in a chorus" energy.' },
    { title: 'Confidence on Stage', body: 'Performance opportunities every term so nerves turn into excitement.' },
  ],
  ageGroups: [
    { ageRange: '4–6', label: 'Mini Stars' },
    { ageRange: '7–10', label: 'Juniors' },
    { ageRange: '11–14', label: 'Inters' },
    { ageRange: '15–18', label: 'Seniors' },
  ],
  relatedLinks: [
    { label: 'Acting Classes Milton Keynes', to: '/acting-classes-milton-keynes' },
    { label: 'Singing Classes Milton Keynes', to: '/singing-classes-milton-keynes' },
    { label: 'Dance Classes Milton Keynes', to: '/dance-classes-milton-keynes' },
    { label: 'Theatre School Milton Keynes', to: '/theatre-school-milton-keynes' },
    { label: 'View the Class Timetable', to: '/schedule' },
    { label: 'Holiday Bootcamps', to: '/bootcamps' },
  ],
};

const MusicalTheatreMK = () => <SeoLandingPage config={config} />;
export default MusicalTheatreMK;
